import { useTranslation } from "react-i18next";
import { TgModel } from "../../../pages/NewTG/Models/store/tg-model-store";
import ConfirmationPopup from "../../common/ConfirmationPopup/ConfirmationPopup";

const TgEvolvePopup = ({
	open,
	onClose,
	model,
	feedbacksCount,
	onEvolve,
}: {
	open: boolean;
	onClose: () => void;
	model: TgModel;
	feedbacksCount: number;
	onEvolve: () => void;
}) => {
	const { t } = useTranslation("tg", { keyPrefix: "models.viewer.evaluation.evolvePopup" });

	return (
		<ConfirmationPopup
			open={open}
			onClose={onClose}
			title={t("title")}
			description={t("description", { feedbacksCount, modelName: model.name })}
			maxWidth="600px"
			confirmButtonText={t("primaryButton")}
			firstButtonText={t("secondaryButton")}
			onClick={onEvolve}
			onSecondaryClick={onClose}
		/>
	);
};

export default TgEvolvePopup;
